module.exports = __webpack_public_path__ + "img/14手机.46f08327.png";